// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highcharts-series path{height:1.04167vw}.timecolor{color:#1bce62}.deliverGreen{padding:0 .41667vw;background:rgba(27,206,98,.55);border-radius:.3125vw;border:1px solid #2deb79}.deliverRed{padding:0 .41667vw;background:rgba(255,77,79,.55);border-radius:.3125vw;border:1px solid #ff4d4f}", ""]);
// Exports
module.exports = exports;
